import AsyncSelect from 'react-select/async';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React, { useState } from 'react';
import { cn } from '../utils/cn';

const AsyncInput = ({ placeholder = 'Поиск...', handleSearch, prefix, defaultValue, loadOptions, defaultOptions = false, className }) => {
  const [selected, setSelected] = useState(defaultValue);
  const [inputValue, setInputValue] = useState('');

  const handleChange = (option) => {
    setSelected(option);
    handleSearch?.(option?.value);
  };

  const handleReset = () => {
    if (selected) {
      setSelected(null);
      handleSearch?.(null);
    }
  };

  return (
    <div className={cn(`flex items-center bg-white border border-gray-300 rounded-lg shadow-sm`, className)}>
      {prefix && <div className="flex pl-2">{prefix}</div>}

      <div className="flex-1">
        <AsyncSelect
          noOptionsMessage={() => (inputValue.length < 1 ? null : 'Ничего не найдено')}
          loadingMessage={() => 'Загрузка...'}
          onInputChange={(value) => setInputValue(value)}
          value={selected}
          loadOptions={loadOptions}
          onChange={handleChange}
          placeholder={placeholder}
          cacheOptions
          defaultOptions={defaultOptions}
          classNamePrefix="react-select"
          styles={{
            control: (base) => ({ ...base, border: 'none', boxShadow: 'none', minHeight: 'unset', borderRadius: '12px' }),
            dropdownIndicator: () => ({ display: 'none' }),
            clearIndicator: (base) => ({ ...base, padding: 4 }),
            valueContainer: (base) => ({ ...base, padding: '7px' }),
            input: (base) => ({ ...base, margin: 0, padding: 0 }),
            indicatorsContainer: (base) => ({ ...base, height: '100%' }),
            placeholder: (base) => ({ ...base, color: '#9da4b0', fontSize: '14px' }),
            option: (base, state) => ({
              ...base,
              color: 'black',
              cursor: 'pointer',
              backgroundColor: state.isSelected || state.isFocused ? '#fff3eb' : 'white',
            }),
          }}
        />
      </div>

      <CloseOutlinedIcon fontSize="inherit" className="cursor-pointer flex w-4 h-4 mr-2 text-gray-500" onClick={handleReset} />
    </div>
  );
};
export default AsyncInput;
